import { ClassRoomAgGrid } from "./AgGrid/ClassRoomAgGrid.tsx";
import { useConfirm } from "../UI/Feedback/useConfirm.ts";
import { useToast } from "../UI/Feedback/useToast.ts";
import { Layout } from "../UI/Layout/Layout.tsx";
import dayjs from "dayjs";
import { useDeleteClassRoom } from "./useDeleteClassRoom.ts";
import { useToClassRoomDetail } from "./useToClassRoomDetail.ts";
import { ClassRoomAgGridDTO } from "./AgGrid/ClassRoomAgGridDTO.ts";
import { useCallback } from "react";
import { OutlinedButton } from "../UI/OutlinedButton.tsx";
import { useNavigate } from "react-router-dom";
import { CreateClassroomScreenPath } from "./CreateClassroom/CreateClassroomScreen.tsx";

export const AgGridClassRoomListPath = "/classrooms";
export function AgGridClassRoomListScreen() {
  const { deleteClassRoom } = useDeleteClassRoom();
  const { toClassRoomDetail } = useToClassRoomDetail();
  const navigate = useNavigate();
  const askConfirmation = useConfirm();
  const showToast = useToast();
  const deleteClass = useCallback(
    async (classRoom: ClassRoomAgGridDTO) => {
      if (dayjs(classRoom.startUtc).isBefore(dayjs()))
        return showToast(
          "You can't delete a class that has already started",
          "error",
        );
      if (
        await askConfirmation({
          title: "Delete this class?",
          message: "Both the students and the teacher will be notified.",
          confirmLabel: "Delete",
          isDestructive: true,
        })
      ) {
        await deleteClassRoom(classRoom.id);
      }
    },
    [deleteClassRoom, askConfirmation, showToast],
  );
  return (
    <Layout maxWClass={"max-w-full"}>
      <ClassRoomAgGrid
        deleteClassRoom={deleteClass}
        toClassRoomDetail={toClassRoomDetail}
        rightButtons={[
          <OutlinedButton
            onClick={() => navigate(CreateClassroomScreenPath)}
            key={"new-class"}
            label={"New class"}
          />,
        ]}
      />
    </Layout>
  );
}
